import type { FC, ReactElement } from 'react';
import { useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { Box, RFFCheckInput } from '@qwealth/qcore';
import { CheckboxGrid, type ContactListItem } from '@qwealth/qvault';

import TransitionBox from '../Households/Common/QNotes/TransitionBox';

interface Props {
  allMembers: ContactListItem[];
  disabledQids: string[];
}

export const MeaningfulContent: FC<Props> = ({ allMembers, disabledQids }): ReactElement | null => {
  const { values: { isMeaningfulInteraction, selectAllRelatedMembers } } = useFormState();
  const form = useForm();

  const allDisabled = allMembers.length > 0 && allMembers.every(m => disabledQids.includes(m.qid));

  useEffect(() => {
    form.change(
      'relatedMembersChecked',
      allMembers.map((m) => disabledQids.includes(m.qid)),
    );
  }, [allMembers, disabledQids.join('')]);

  useEffect(() => {
    if (selectAllRelatedMembers !== undefined) {
      form.change(
        'relatedMembersChecked',
        allMembers.map((m) => selectAllRelatedMembers || disabledQids.includes(m.qid)),
      );
    }
  }, [selectAllRelatedMembers, allMembers, form]);

  if (!isMeaningfulInteraction) {
    return null;
  }

  return (
    <TransitionBox index={0} isVisible width="100%">
      <Box fontWeight="bold" marginBottom="default">
        Please Select all clients the meaningful interaction pertains to.
      </Box>
      <Box display="flex" alignItems="center" gap="default" marginBottom="default" paddingLeft="default">
        <RFFCheckInput name="selectAllRelatedMembers" initialValue={allDisabled || undefined} inputFieldProps={{ disabled: allDisabled }} />
        <Box as="label">Select all Clients & Legal Entities</Box>
      </Box>
      <CheckboxGrid items={allMembers} fieldName="relatedMembersChecked" disabledQids={disabledQids} />
    </TransitionBox>
  );
};
